











































import { Component, Prop, Vue } from 'vue-property-decorator';
import posed, { PoseTransition } from 'vue-pose';
import { LeftBarNotificationProp } from '@/store/modules/topBarTypes';
import ArrowLinkUp from '@/components/icons/ArrowLinkUp.vue';

@Component({
  components: {
    PoseTransition,
    AnimatedNotification: posed.div({
      enter: { opacity: 1, transition: { duration: 100 } },
      exit: { opacity: 0 }
    }),
    ArrowLinkUp
  }
})
export default class LeftBarNotificationArrow extends Vue {
  @Prop({ default: {} }) notification!: LeftBarNotificationProp;
  @Prop({ default: {} }) menuNotificationOffset!: any;

  goToLearnMore() {
    window.open(this.notification.learnMoreLink, '_blank');
    if (this.notification.learnMoreClick) this.notification.learnMoreClick();
  }
}
